module.exports = __webpack_public_path__ + "static/media/agroemisja.29cc6c83.png";